// pages/CronManager.jsx
import React, { useEffect, useState } from "react";
import api from "../utils/api";
import { URLS } from "../utils/urls";
import { SERVICES, INTERVALS } from "../utils/cronOptions";

const CronManager = () => {
  const [jobs, setJobs] = useState([]);
  const [service, setService] = useState("");
  const [interval, setInterval] = useState("");

  const fetchJobs = async () => {
    const res = await api.get(URLS.CRONJOBS);
    setJobs(res.data.jobs || []);
  };

  const addJob = async () => {
    if (!service || !interval) return alert("Select service and interval");

    const selectedService = SERVICES.find((s) => s.id === service);
    const selectedInterval = INTERVALS.find((i) => i.id === interval);

    const payload = {
      id: `${service}-${interval}`,
      cronExpression: selectedInterval.expression,
      description: `${selectedService.title} (${selectedInterval.label})`,
      type: `report:${service}`,
    };

    await api.post(URLS.CRONJOBS, payload);
    fetchJobs();
    setService("");
    setInterval("");
  };

  const deleteJob = async (jobId) => {
    await api.delete(`${URLS.CRONJOBS}/${jobId}`);
    fetchJobs();
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-6">📅 Cronjob Manager </h2>

      {/* Create Job */}
      <div className="bg-white shadow-md rounded-xl p-6 mb-8">
        <h3 className="text-lg font-semibold mb-4">Create New Job</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Service Selection */}
          <div>
            <label className="block text-sm font-medium mb-1">Select Service</label>
            <select
              className="border rounded-lg p-2 w-full"
              value={service}
              onChange={(e) => setService(e.target.value)}
            >
              <option value="">-- Select Service --</option>
              {SERVICES.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.title} — {s.description}
                </option>
              ))}
            </select>
          </div>

          {/* Interval Selection */}
          <div>
            <label className="block text-sm font-medium mb-1">Select Interval</label>
            <select
              className="border rounded-lg p-2 w-full"
              value={interval}
              onChange={(e) => setInterval(e.target.value)}
            >
              <option value="">-- Select Interval --</option>
              {INTERVALS.map((i) => (
                <option key={i.id} value={i.id}>
                  {i.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <button
          className="mt-4 bg-[#db8654] hover:bg-[#c57445] text-white px-5 py-2 rounded-lg font-medium transition"
          onClick={addJob}
        >
         Create Job
        </button>
      </div>

      {/* List Jobs */}
      <h3 className="text-lg font-semibold mb-3">Active Jobs</h3>
      {jobs.length === 0 ? (
        <p className="text-gray-500">No cron jobs created yet.</p>
      ) : (
        <ul className="space-y-3">
          {jobs.map((job) => (
            <li
              key={job.id}
              className="flex justify-between items-center bg-gray-50 border rounded-lg p-4 shadow-sm"
            >
              <div>
                <p className="font-medium">{job.description || job.id}</p>
                <p className="text-sm text-gray-600">
                  {job.type} — <code>{job.cronExpression}</code>
                </p>
              </div>
              <button
                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded-lg transition"
                onClick={() => deleteJob(job.id)}
              >
                 Delete
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CronManager;
